// extracted by mini-css-extract-plugin
export var arrow = "_2q-6";
export var changeItem = "_2q-3";
export var changesHeader = "_2q-1";
export var changesList = "_2q-2";
export var container = "_2q-0";
export var pathLabel = "_2q-4";
export var value = "_2q-7";
export var valuesContainer = "_2q-5";